import type { AxiosInstance } from 'axios';

import type { TTrajectory } from '../../types/trajectory';
import { throwApiError } from '../../utils/errors';

export class TrajectoriesApi {
  private readonly agent: AxiosInstance;

  constructor(agent: AxiosInstance) {
    this.agent = agent;
  }

  async fetchByWellbore(wellboreId: number, signal?: AbortSignal): Promise<TTrajectory[]> {
    try {
      const { data } = await this.agent.get<TTrajectory[]>(`trajectories/${wellboreId}`, {
        signal,
      });

      return data ?? [];
    } catch (e) {
      throwApiError(e);
    }
  }
}
